import { render } from "./Header.vue?vue&type=template&id=ad81671e"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script